<!--
CONSULTA ESTOQUE DISPONIVEL DO PRODUTO

- filtrar o produto
- filtrar filial
- filtrar nr do lote



FALTA:
- marcação para lote bloqueado e lote vencido
- botões de ações para transferência de depósito, ajuste, etc
- campo total do estoque disponível
- campo total do estoque bloqueado
- campo total do estoque vencido
- campo total do estoque alocado
- totalizar movimentos de entrada/saída
  -->


<template>
  <div class="container-full-width default-container p-3">
    <!-- <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro"
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    /></filtro> -->

    <div class="row">
      <div class="col-12 mb-2">
        <span class="lbl-deal-title mb-2 w-100">ESTOQUE DO PRODUTO</span>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar">
        </v-button>
      </div>
    </div>
    <hr>
    <div class="row align-items-center">
      <form-field v-model="coditem" type="select2" col="6" :metadata="metadata.pedvit.coditem"></form-field>
      <div class="col-12">
        <v-button label="Mais Filtros" data-toggle="collapse" data-target="#maisFiltros" aria-expanded="false"
          aria-controls="maisFiltros"></v-button>
      </div>
    </div>
    <div class="row collapse align-items-center" id="maisFiltros">
      <form-field v-model="codfil" type="select2" col="4" :metadata="metadata.nf.codfil"></form-field>
      <form-field v-model="lote" type="text" col="2" :metadata="metadata.mest.lote"></form-field>
      <div class="col-12">
        <v-button label="Pesquisar" aria-expanded="false" @click="handlePesquisar"></v-button>
      </div>
    </div>

    <hr>

    <div class="row" v-if="coditem">
      <div class="col-12 lbl-title">
        ESTOQUE DISPONÍVEL
        <!-- <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button> -->
      </div>
    </div>

    <div class="row p-3" v-if="coditem && estoque.length">
      <div class="col-md-5 col-sm-6 col-12">
        <label class="lbl-list w-100">Quantidade Disponível</label><span class="consulta__total_valor">{{
            dados.estoque.total.estoque_disponivel | formatValue(4)
        }}</span>
      </div>
      <div class="col-md-5 col-sm-6 col-12">
        <label class="lbl-list w-100">Quantidade</label><span class="consulta__total_valor">{{
            dados.estoque.total.estoque_quantidade | formatValue(4)
        }}</span>
      </div>
    </div>

    <div class="row p-3" v-if="coditem && estoque.length">
      <div class="col-md-4 col-12">
        <label class="lbl-list w-100">Quantidade Alocada</label><span class="consulta__total_valor">{{
            dados.estoque.total.estoque_alocado | formatValue(4)
        }}</span>
      </div>
      <div class="col-md-4 col-12" v-if="dados.controlalote">
        <label class="lbl-list w-100">Quantidade Lotes Bloqueados</label><span class="consulta__total_valor">{{
            dados.estoque.total.estoque_bloqueado | formatValue(4)
        }}</span>
      </div>
      <div class="col-md-4 col-12" v-if="dados.controlalote">
        <label class="lbl-list w-100">Quantidade Lotes Vencidos</label><span class="consulta__total_valor">{{
            dados.estoque.total.estoque_vencido | formatValue(4)
        }}</span>
      </div>
    </div>

    <div class="row" v-if="coditem && !estoque.length">
      <div class="col-12">
        Estoque indisponível para o produto
      </div>
    </div>

    <button v-if="coditem" @click="handleAjustarEstoque(null)" class="btn nb-btdef my-3">Ajustar Estoque</button>

    <div class="row" v-if="coditem">
      <div class="col-12 lbl-title">
        ESTOQUE DETALHADO POR DEPÓSITOS / LOTES
      </div>
    </div>

    <div class="mainbox-select" v-for="(row, index) in estoque" :key="index">
      <div class="box">
        <div class="row">
          <div class="col-md-2 col-3">
            <label class="lbl-list w-100">Depósito</label>
            <span class="data-list">{{ row.descricao }}</span>
            <!-- <span class="data-list">{{ nf.data | formatData }}</span> -->
          </div>
          <div class="col-md-1 col-3" v-if="row.linha && row.linha !== ''">
            <label class="lbl-list w-100">Linha(Grade)</label>
            <span class="data-list">{{ row.linha }}</span>
          </div>
          <div class="col-md-1 col-3" v-if="row.coluna && row.coluna !== ''">
            <label class="lbl-list w-100">Coluna(Grade)</label>
            <span class="data-list">{{ row.coluna }}</span>
          </div>

          <div class="col-md-2 col-3">
            <label class="lbl-list w-100">Qtd. Disponível</label>
            <span class="data-list">{{ row.qtdisponivel | formatValue(4) }}</span>
          </div>
          <div class="col-md-1 col-3">
            <label class="lbl-list w-100">Quantidade</label>
            <span class="data-list">{{ row.qt | formatValue(4) }}</span>
          </div>
          <div class="col-md-1 col-3">
            <label class="lbl-list w-100">Qtd. Alocada</label>
            <span class="data-list">{{ row.qtalocado | formatValue(4) }}</span>
          </div>
          <div class="col-md-1 col-3" v-if="dados.controlalocal">
            <label class="lbl-list w-100">Local</label>
            <span class="data-list">{{ row.local }}</span>
          </div>
          <div class="col-md-1 col-2" v-if="dados.controlalote">
            <label class="lbl-list w-100">Lote</label>
            <span class="data-list">{{ row.lote }}</span>
            <span v-if="row.lotebloqueado" class="badge badge-yellow" data-toggle="tooltip" data-placement="top"
              title="Lote bloqueado para consumo">Bloqueado</span>
          </div>
          <div class="col-md-1 col-2" v-if="dados.controlalote">
            <label class="lbl-list w-100">Sublote</label>
            <span class="data-list">{{ row.sublote }}</span>
          </div>
          <div class="col-md-2 col-2" v-if="dados.controlalote">
            <label class="lbl-list w-100">Validade</label>
            <span class="data-list">{{ row.dtval | formatData }}</span>
            <span v-if="row.lotevencido" class="badge badge-yellow" data-toggle="tooltip" data-placement="top"
              title="Lote com data de validade expirada">Vencido</span>
          </div>
          <div class="col-md-auto col-12">
            <bar-grid :options="{ barDefault: true, btnView: false }" :moreActions="getActions(row)"
              @action="handleActionItem">
            </bar-grid>
          </div>
        </div>
        <div class="row" v-if="dados.controlalote">
          <div class="col-md-12">
            <a style="cursor: pointer; color: #0091ea;" data-toggle="collapse" :data-target="'#detalheLote' + index"
              aria-expanded="false" :aria-controls="'detalheLote' + index">Detalhar</a>
          </div>
        </div>
        <div class="row collapse" :id="'detalheLote' + index" v-if="dados.controlalote">
          <div class="col-md-2 col-3">
            <label class="lbl-list w-100">Dias Validade</label>
            <span class="data-list">{{ row.diasvalidade }}</span>
          </div>
          <div class="col-md-2 col-3">
            <label class="lbl-list w-100">Lote Fornecedor</label>
            <span class="data-list">{{ row.loteforn }}</span>
          </div>
          <div class="col-md-2 col-3">
            <label class="lbl-list w-100">Fornecedor do lote</label>
            <span class="data-list">{{ row.loteforn }}</span>
          </div>
          <div class="col-md-2 col-3">
            <label class="lbl-list w-100">Data de Entrada</label>
            <span class="data-list">{{ row.loteforn }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!coditem">
      <div class="col-12 lbl-title mb-2">
        Selecione um Produto
        <!-- <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button> -->
      </div>
    </div>

    <div class="row col" v-if="showGradeItem">
      <span class="lbl-title-produto mb-3">Estoque em Grade</span>
      <div class="row col">
        <grade-estoque ref="grade-estoque" :params="{ view: true, coditem: this.coditem }"></grade-estoque>
      </div>
    </div>


    <div class="row" v-if="coditem">
      <div class="col-md-12 col-12 lbl-title">
        MOVIMENTOS
        <!-- <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button> -->
      </div>
      <div class="col-md-3 col-6">
        <input-month :p-month="filtroPeriodo" :show-options="true" @monthChange="handleMonthChange"></input-month>
      </div>
    </div>

    <div class="row p-3" v-if="coditem && movimento.length">
      <div class="col-md-5 col-sm-7 col-12">
        <label class="lbl-list w-100">Total de Entradas no Período</label><span class="consulta__total_valor">{{
            dados.movimentos.total.entradas | formatValue(4)
        }}</span>
      </div>
      <div class="col-md-5 col-sm-5 col-12">
        <label class="lbl-list w-100">Total de Saídas no Período</label><span class="consulta__total_valor">{{
            dados.movimentos.total.saidas | formatValue(4)
        }}</span>
      </div>
    </div>


    <div class="row mb-5" v-if="coditem">
      <div class="col-12" v-if="movimento.length == 0">
        Sem movimentos para o período
      </div>
      <div class="col-12" v-else>
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-striped table-hover responsive tablesorter w-100">
              <thead>
                <tr>
                  <template v-for="col in movCols">
                    <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in movimento" :key="index">
                  <td class="textual">{{ row.data | formatData }}</td>
                  <td class="textual">{{ row.tipo }}</td>
                  <td class="textual">{{ textTipoDocumento(row.tipodocumento) }}
                    {{ row.tipodocumento }}
                    <span v-if="row.varejo == 'S'" class="float-right badge badge-orange">Varejo</span>
                  </td>
                  <td class="textual">{{ row.documento }}
                    <div class="row" v-if="row.tipodocumento == 'AJ'">
                      <div class="col-md-12">
                        <a style="cursor: pointer; color: #0091ea;" data-toggle="collapse"
                          :data-target="'#detalheMovimento' + index" aria-expanded="false"
                          :aria-controls="'detalheLote' + index">Detalhar</a>
                      </div>
                    </div>
                    <div class="row collapse" :id="'detalheMovimento' + index" v-if="row.tipodocumento == 'AJ'">
                      <div class="col-md-2 col-3">
                        <label class="lbl-list w-100">Observação</label>
                        <span class="data-list">{{ row.obs }}</span>
                      </div>
                    </div>

                  </td>
                  <td class="numerico size130">{{ row.qt | formatValue(4) }}</td>
                  <td class="textual">{{ row.coddeposito }} - {{ row.deposito }}</td>
                  <td class="textual">{{ row.linha }}</td>
                  <td class="textual">{{ row.coluna }}</td>
                  <td class="textual">{{ row.lote }}</td>
                  <td class="textual">{{ row.sublote }}</td>
                  <td class="textual">{{ row.dtval | formatData }}</td>
                  <td class="textual">{{ row.loteforn }}</td>
                  <td class="textual">{{ row.nome_usuario }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <!-- <th class="text-right total">Total</th> -->
                  <!-- <th class="numerico total" style="border-left: 1px solid #dee2e6;">{{ dados.total.quantidade }}</th>
                        <th class="numerico total">{{ dados.total.valor | formatValue(2) }}</th> -->
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <button v-if="coditem" @click="showDetalhesAlocacao" class="btn nb-btdef mb-3">Ver/Ocultar Detalhes
      Alocação</button>

    <div class="row" v-if="coditem && viewDetalhesAlocacao">
      <div class="col-md-12 col-12 lbl-title">
        ALOCAÇÃO
        <!-- <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button> -->
      </div>
    </div>

    <!-- Detalhes de Alocação -->
    <div class="row p-3" v-if="coditem && alocacao.length && viewDetalhesAlocacao">
      <!-- <div class="col-md-5 col-sm-7 col-12">
          <label class="lbl-list w-100">Total de Entradas no Período</label><span class="consulta__total_valor">{{ dados.movimentos.total_alocacao.entradas | formatValue(4) }}</span>
        </div> -->
      <div class="col-md-5 col-sm-5 col-12">
        <label class="lbl-list w-100">Quantidade Total Alocada</label><span class="consulta__total_valor">{{
            dados.movimentos.total_alocacao.saidas | formatValue(4)
        }}</span>
      </div>
    </div>

    <div class="row mb-5" v-if="coditem && viewDetalhesAlocacao" id="alocacao">
      <div class="col-12" v-if="alocacao.length == 0">
        Sem alocações para o período
      </div>
      <div class="col-12" v-else>
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-striped table-hover responsive tablesorter w-100">
              <thead>
                <tr>
                  <template v-for="col in movCols">
                    <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in alocacao" :key="index">
                  <td class="textual">{{ row.data | formatData }}</td>
                  <td class="textual">{{ row.tipo }}</td>
                  <td class="textual">{{ textTipoDocumento(row.tipodocumento) }}
                    {{ row.tipodocumento }}
                    <span v-if="row.varejo == 'S'" class="float-right badge badge-orange">Varejo</span>
                  </td>
                  <td class="textual">{{ row.documento }}
                    <div class="row" v-if="row.tipodocumento == 'AJ'">
                      <div class="col-md-12">
                        <a style="cursor: pointer; color: #0091ea;" data-toggle="collapse"
                          :data-target="'#detalheMovimento' + index" aria-expanded="false"
                          :aria-controls="'detalheLote' + index">Detalhar</a>
                      </div>
                    </div>
                    <div class="row collapse" :id="'detalheMovimento' + index" v-if="row.tipodocumento == 'AJ'">
                      <div class="col-md-2 col-3">
                        <label class="lbl-list w-100">Observação</label>
                        <span class="data-list">{{ row.obs }}</span>
                      </div>
                    </div>

                  </td>
                  <td class="numerico size130">{{ row.qt | formatValue(4) }}</td>
                  <td class="textual">{{ row.coddeposito }} - {{ row.deposito }}</td>
                  <td class="textual">{{ row.lote }}</td>
                  <td class="textual">{{ row.sublote }}</td>
                  <td class="textual">{{ row.dtval | formatData }}</td>
                  <td class="textual">{{ row.loteforn }}</td>
                  <td class="textual">{{ row.nome_usuario }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <!-- <th class="text-right total">Total</th> -->
                  <!-- <th class="numerico total" style="border-left: 1px solid #dee2e6;">{{ dados.total.quantidade }}</th>
                        <th class="numerico total">{{ dados.total.valor | formatValue(2) }}</th> -->
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>


    <!-- AJUSTE OU TRANSFERENCIA DE ESTOQUE -->
    <div class="nb-modal-scrollable" v-if="showAjusteTransferenciaForm">
      <div class="nb-modal-scrollable-container" style="padding: 15px; width: 90%">
        <div class="nb-modal-scrollable-body">
          <estoque-ajuste-transferencia-form :params="paramsAjusteTransferencia" @closeform="closeAjusteForm">
          </estoque-ajuste-transferencia-form>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
import EstoqueAjusteTransferenciaForm from '../forms-estoque/estoque-ajuste-transferencia-form'
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";
import { getText } from '../shared/utils'
import BarGrid from '../components/bar-grid'
import gradeEstoque from '../components/grade-estoque'

export default {

  components: {
    Filtro,
    Chart,
    BarGrid,
    EstoqueAjusteTransferenciaForm,
    gradeEstoque
  },

  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      coditem: null,
      lote: null,
      codfil: null,

      dados: {},

      estoqueCols: [],
      movCols: [],

      mounting: false,

      maisFiltro: false,

      filtroPeriodo: {            //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null,
      },

      showAjusteTransferenciaForm: false,
      paramsAjusteTransferencia: null,
      viewDetalhesAlocacao: false
    };
  },

  watch: {
    coditem: function () {
      this.loadData()
    },
  },

  methods: {
    handleCloseFiltro() {
      this.showfiltro = false
    },
    handlePesquisar() {
      this.loadData();
    },

    closeAjusteForm() {
      this.$modalForm(false)
      this.showAjusteTransferenciaForm = false
      this.loadData()
    },

    handleTransferirEstoque(codqest) {
      this.paramsAjusteTransferencia = { transferencia: true, codqest: codqest, coditem: this.coditem }
      this.showAjusteTransferenciaForm = true
      this.$modalForm(true)
    },

    handleAjustarEstoque(codqest) {
      this.paramsAjusteTransferencia = { ajuste: true, codqest: codqest, coditem: this.coditem }
      this.showAjusteTransferenciaForm = true
      this.$modalForm(true)
    },

    clickRetornar() {
      this.$router.back()
    },

    handleMonthChange() {
      this.loadData()
    },

    handleSelectItem() {
      this.loadData()
    },

    getActions(estoque) {
      var moreActions = []
      var act = { action: 1, label: 'Transferir Depósito', id: estoque.codqest }
      moreActions.push(act)
      var act = { action: 2, label: 'Ajustar Estoque', id: estoque.codqest }
      moreActions.push(act)
      //        var act = { action: 3, label: 'Bloquear Lote', id: estoque.codqest }
      //        moreActions.push(act)
      return moreActions
    },

    textTipoDocumento(value) {
      return getText(value, this.metadata.mest.tpdocest)
    },

    handleActionItem(action, obj, actionObj) {


      // parametro ID = estoque.codqest

      if (action == 2) { //ajustar
        //this.$router.push('/estoque/ajuste/novo/1663')
        this.handleAjustarEstoque(actionObj.id)
      }

      if (action == 1) { //transferir estoque
        this.handleTransferirEstoque(actionObj.id)
      }

      //     if (action == 3) { //bloquear lote
      //       this.$router.push('/estoque/bloqueiolote/')
      //     }

    },

    montaColunas() {
      this.estoqueCols = [
        { nome: 'quantidade', visible: true, label: 'Quantidade', indexperiodo: null, sortable: true, orderby: 'desc', class: 'numerico size130', style: '' },
        { nome: 'coddeposito', visible: true, label: 'Depósito', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' },
        { nome: 'lote', visible: true, label: 'Lote', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'sublote', visible: true, label: 'Sublote', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'dtval', visible: true, label: 'Validade', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'diasvalidade', visible: true, label: 'Dias', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'loteforn', visible: true, label: 'Lote Fornecedor', sortable: true, orderby: null, class: '', style: '' },
        // { nome: 'descricao_produto', visible: true, label: 'Produto', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' },
        // { nome: 'id', visible: false, label: 'Código' },
      ]

      this.movCols = [
        { nome: 'data', visible: true, label: 'Data', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'tipo', visible: true, label: 'Movimento', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'tipodocumento', visible: true, label: 'Tipo Documento', sortable: true, orderby: null, class: '', style: '' },
        //{ nome: 'nf', visible: true, label: 'Nota Fiscal', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'documento', visible: true, label: 'Documento', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'quantidade', visible: true, label: 'Quantidade', indexperiodo: null, sortable: true, orderby: 'desc', class: 'numerico size130', style: '' },
        { nome: 'coddeposito', visible: true, label: 'Depósito', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' },
        { nome: 'linha', visible: true, label: 'Linha(Grade)', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'coluna', visible: true, label: 'Coluna(Grade)', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'lote', visible: true, label: 'Lote', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'sublote', visible: true, label: 'Sublote', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'dtval', visible: true, label: 'Validade', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'loteforn', visible: true, label: 'Lote Fornecedor', sortable: true, orderby: null, class: '', style: '' },
        { nome: 'nome_usuario', visible: true, label: 'Usuário', sortable: true, orderby: null, class: '', style: '' },
      ]
      // this.colunas.push({ nome: 'valor', visible: true, label: 'Valor Total', sortable: true, orderby: null, class: 'numerico size130', style: '' })

    },

    // handleShowFiltro() {
    //   this.showfiltro = true;
    // },

    // filtroChange(filtro) {
    //   this.showfiltro = false;

    //   this.filtro = filtro;

    //   this.paramsFiltro.filtros[0].values = this.filtro.filial
    //   this.paramsFiltro.filtros[1].values = this.filtro.segmento
    //   this.paramsFiltro.filtros[2].values = this.filtro.grupocliente
    //   this.paramsFiltro.filtros[3].values = this.filtro.estado
    //   this.paramsFiltro.filtros[4].values = this.filtro.grupoestoque

    //   this.loadData();
    // },

    showDetalhesAlocacao() {
      this.viewDetalhesAlocacao = !this.viewDetalhesAlocacao

      setTimeout(() => {
        const element = document.getElementById("alocacao");
        element.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 500);
    },

    async loadData(excel) {
      if (!this.coditem) {
        this.dados = {}
        return;
      }

      let url = "consulta/estoque/estoqueproduto";

      this.filtro = {
        coditem: this.coditem,
        codfil: this.codfil,
        lote: this.lote,
        data_inicio: this.filtroPeriodo.startDate,
        data_termino: this.filtroPeriodo.endDate,
      }

      this.filtro.excel = excel;

      if (excel)
        apiDownload2(this, url, this.filtro, "post")
      else {
        this.mounting = true
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          this.dados = data;
        } else {
          this.dados = {};
        }
      }
      this.montaColunas()
      this.mounting = false

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },
  },

  computed: {
    showGradeItem: function () {
      return this.dados.isgrade && !this.mounting
    },

    estoque: function () {
      if (!this.dados.estoque || !this.dados.estoque.detalhes)
        return []
      else
        return this.dados.estoque.detalhes
    },
    movimento: function () {
      if (!this.dados.movimentos || !this.dados.movimentos.detalhes)
        return []
      else
        return this.dados.movimentos.detalhes
    },
    alocacao: function () {
      if (!this.dados.movimentos || !this.dados.movimentos.detalhes_alocacao)
        return []
      else
        return this.dados.movimentos.detalhes_alocacao
    },
  },

  mounted() {
    // this.coditem = '1663'

  },

  created() {
    if (this.$route.query.coditem) {
      this.coditem = this.$route.query.coditem
    }
    // this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
    // this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())
  },
}


</script>

<style>
table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .total {
  background: #c1c4c7;
  border: none;
}

table .var {
  min-width: 85px;
  text-align: center;
  background: #c1c4c7;
  display: inline-block;
}

table .var-negative {
  color: white;
  background: indianred;
}

table .var-positive {
  color: white;
  background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 24px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/consultas/consulta-estoque-produto.vue